import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { cloneDeep } from 'src/ep-utils';
import { DocumentFileComponent } from '../../../Views/Work/Accounts/proprietary/controls/document-controls/document-file/document-file.component';
import { MultiDocumentFileComponent } from '../../../Views/Work/Accounts/proprietary/controls/document-controls/multi-document-file/multi-document-file.component';
import { DocumentDistributeObjectService } from '../../models/proprietary/document-distribute/document-distribute-object.service';
import { DocumentDistributeObjectState } from '../../models/proprietary/document-distribute/document-distribute-object.state';
import { DocumentObjectService } from '../../models/proprietary/document/document-object.service';
import { TaskObjectService } from '../../models/proprietary/task/task-object.service';
import { AppService } from './app.service';
import { DataService } from './data.service';
import { DataSourceStatus, Datasource } from './datasource';
import { DocumentDistributeService } from './document-distribute.service';
import { DistributeActionType, DistributeResultType } from './document-distribute.types';
import { FileActionType } from './document-file.types';
import { ObjectService } from './object.service';

export class DocumentFilingType {
    Distribute?: { Method: string }; //F=File, Q=Queue
    Entity?: { Entity_ID: string; Role_Type: string };
    Contract?: { Contract_ID: string };
    Claim?: { Claim_ID: string };
    File_Drawer?: string;
    File_Folder?: string;
    Public_Document_Ind?: string;
    Common_Doc_Ind?: string;
}

export class DocumentType {
    Doc_ID: string;
    Doc_Name?: string;
    Doc_Desc?: string;
    Doc_Class?: string;
    Doc_Data?: {};
    Dist_Method?: string;
    Viewed_Ind?: string;
    Created_By?: { Entity_ID?: ''; Entity_Name?: ''; Date?: '' };
    Base_Doc_Type?: string;
    PDF_Renderable?: string;
    Filed_Ind?: string;
}

@Injectable({
    providedIn: 'root'
})
export class DocumentFileService {
    public dsDocument: Datasource; //TODO: Is it okay to make this datasource public? How else to subscribe to it's status from other components?
    dsReportData: Datasource;
    public callbackFunction: any = null;
    public reportProcessBody: any = null;
    public callPostDistribute: boolean = false;
    private reloadTaskID: null;

    //TODO:  Should this service be part of DocumentOS???

    documentSub: Subscription;
    dsDocumentStatusSub: Subscription;
    reportSub: Subscription;

    constructor(
        private app: AppService,
        private ds: DataService,
        private taskOS: TaskObjectService,
        private distributeService: DocumentDistributeService,
        private documentDistributeOS: DocumentDistributeObjectService,
        private store: Store,
        private modalService: NgbModal,
        private documentOS: DocumentObjectService,
        private objectOS: ObjectService
    ) {
        this.dsDocument = this.ds.addNewDatasource('Document', 'NO-CACHE');
        this.dsReportData = ds.addNewDatasource('Report', 'NO-CACHE');
    }

    file(document: DocumentType, callback: any = null) {
        // this.taskOS.suppressTaskHeader(true); // prevents the task header from displaying on doc page while doc filing action is in process
        this.documentOS.loadDocument(document.Doc_ID);
        const modalRef = this.modalService.open(DocumentFileComponent, { centered: true, size: 'lg', backdrop: false });
        modalRef.result.then(
            (result) => {
                if (callback) {
                    callback();
                }
                if (result && result.document && result.action == FileActionType.Distribute) {
                    this.distribute(result.document);
                }
            },
            () => { }
        );
    }

    openMultiDocFile() {
        // this.taskOS.suppressTaskHeader(true); // prevents the task header from displaying on doc page while doc filing action is in process
        const modalRef = this.modalService.open(MultiDocumentFileComponent, {
            centered: true,
            size: 'lg',
            backdrop: false
        });
        modalRef.result.then(
            (result) => {
                // Support MultiDoc Distribute Later
                // if (result && result.documents && result.action == FileActionType.Distribute) {
                //   this.distribute(result.documents);
                // }
            },
            () => { }
        );
    }

    distributeReport(document: DocumentType, reportProcessBody: any, callback: any = null) {
        this.callbackFunction = callback;
        this.reportProcessBody = reportProcessBody;
        let doc = {
            Doc_Name: document.Doc_Name,
            Doc_Desc: document.Doc_Desc,
            Doc_ID: document.Doc_ID,
            Doc_Class: document.Doc_Class,
            Dist_Method: 'Q',
            Base_Doc_Type: document.Base_Doc_Type
        };

        let objectCode = reportProcessBody.ConceptOneRequest.ReportProcess.Object_Code;
        if (objectCode) {
            this.distributeService.callingObjectCode = objectCode;
        }
        this.documentDistributeOS.reset();
        this.documentDistributeOS.addDocument(doc);
        this.distributeService.openDialog(this.returnFromDistributeReport.bind(this));
    }

    private returnFromDistributeReport(result: DistributeResultType) {
        let distMethod: string;

        if (result.action == DistributeActionType.Distribute) {
            let currDocument: DocumentType = null;
            let filings: DocumentFilingType[] = [];
            let docDistStateEntities = this.store.selectSnapshot(DocumentDistributeObjectState.entities);
            docDistStateEntities = cloneDeep(docDistStateEntities);

            for (var i in docDistStateEntities.document) {
                distMethod = docDistStateEntities.document[i].Dist_Method;
                delete docDistStateEntities.document[i].Dist_Method; //Clean up temp object...
                currDocument = docDistStateEntities.document[i];
                break;
            }

            for (var i in docDistStateEntities.filing) {
                if (
                    docDistStateEntities.filing[i].Affiliate &&
                    (docDistStateEntities.filing[i].Affiliate.Entity_ID == null ||
                        docDistStateEntities.filing[i].Affiliate.Entity_ID == '')
                ) {
                    delete docDistStateEntities.filing[i].Affiliate;
                }
                filings.push(docDistStateEntities.filing[i]);
            }

            if (filings.length > 0) {
                this.addReportFiling(currDocument, filings);
                this.callPostDistribute = true;
            }
        }
    }

    // TODO Refactor to support multi documents
    distribute(document: DocumentType, callback: any = null) {
        this.callbackFunction = callback;
        let doc = {
            Doc_Name: document.Doc_Name,
            Doc_Desc: document.Doc_Desc,
            Doc_ID: document.Doc_ID,
            Doc_Class: document.Doc_Class,
            Dist_Method: 'Q',
            Base_Doc_Type: document.Base_Doc_Type
        };

        let objectCode: any;
        //get report object code to pass in to the document distribute dialog
        //to add default file folder and drawer
        let reports: any = this.objectOS.getObjectListByObjectClass(['R'], false, true);
        reports = reports.map((object) => {
            return { Object_Code: object.Object_Code, Object_Name: object.Object_Name };
        });
        for (var i in reports) {
            if (reports[i].Object_Name.toLowerCase() == doc.Doc_Name.toLowerCase()) {
                objectCode = reports[i].Object_Code;
                break;
            }
        }
        if (objectCode) {
            //object code thats passed in to document distribute dialog when a recepient is added
            this.distributeService.callingObjectCode = objectCode;
        }
        this.documentDistributeOS.reset();
        this.documentDistributeOS.addDocument(doc);
        this.distributeService.openDialog(this.returnFromDistribute.bind(this));
    }

    private returnFromDistribute(result: DistributeResultType) {
        let distMethod: string;

        if (result.action == DistributeActionType.Distribute) {
            let currDocument: DocumentType = null;
            let filings: DocumentFilingType[] = [];
            let docDistStateEntities = this.store.selectSnapshot(DocumentDistributeObjectState.entities);
            docDistStateEntities = cloneDeep(docDistStateEntities);

            for (var i in docDistStateEntities.document) {
                distMethod = docDistStateEntities.document[i].Dist_Method;
                delete docDistStateEntities.document[i].Dist_Method; //Clean up temp object...
                currDocument = docDistStateEntities.document[i];
                break; // only one document supported by this distribute function -- support multiple later?
            }

            for (var i in docDistStateEntities.filing) {
                if (
                    docDistStateEntities.filing[i].Affiliate &&
                    (docDistStateEntities.filing[i].Affiliate.Entity_ID == null ||
                        docDistStateEntities.filing[i].Affiliate.Entity_ID == '')
                ) {
                    delete docDistStateEntities.filing[i].Affiliate;
                }
                filings.push(docDistStateEntities.filing[i]);
                // since only one document is supported in this distribute function -- assume all filings are for the one document
            }

            if (filings.length > 0) {
                this.callPostDistribute = true;
                this.addDocumentFiling(currDocument, filings);
            } else {
                if (distMethod == 'P') {
                    this.distributeService.postDistribute(currDocument.Doc_ID, currDocument.Base_Doc_Type);
                }
            }
        }
    }

    addDocumentFiling(document: DocumentType, filings: DocumentFilingType[]): void {
        let newFilings = cloneDeep(filings);

        newFilings.forEach((filing) => {
            filing.Edit_Status = 'A';
            filing.Book = { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID };
            filing.Book_Loc = { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID };

            if (!filing.File_Drawer) {
                filing.File_Drawer = '?';
            }

            if (!filing.File_Folder) {
                filing.File_Folder = '?';
            }

            if (!filing.Public_Document_Ind) {
                filing.Public_Document_Ind = 'N';
            }

            if (!filing.Common_Doc_Ind) {
                filing.Common_Doc_Ind = 'N';
            }

            if (!filing.Distribute) {
                filing.Distribute = { Method: 'F' };
            }

            if (filing.Distribute.Method == 'P') {
                filing.Distribute.Method = 'F';
            }

            if (filing.Distribute.Method == 'C') {
                if (filing.File_Only_Ind == 'Y') {
                    filing.Distribute.Method = 'F';
                } else {
                    filing.Distribute.Method = 'Q';
                }
            }
        });

        const documentProcess = {
            Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
            Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
            Event: 'Update',
            Document: {
                Doc_ID: document.Doc_ID,
                Doc_Name: document.Doc_Name,
                Doc_Desc: document.Doc_Desc,
                Doc_Class: document.Doc_Class,
                Filing: newFilings
            }
        };

        const body = {
            '?xml': { '@version': '1.0' },
            ConceptOneRequest: {
                DocumentProcess: {
                    View: 'Full',
                    Keep_Project_Open: 'Y',
                    Session_ID: this.taskOS.currentProjectID,
                    ...documentProcess
                }
            }
        };

        if (this.documentSub) {
            this.documentSub.unsubscribe();
        }
        this.dsDocument.reset(); //so that current "READY" status won't fire for new subscription
        this.documentSub = this.dsDocument.status$
            .pipe(
                filter((status) => status === DataSourceStatus.Ready),
                map(() => this.documentUpdated())
            )
            .subscribe();
        this.dsDocument.process({ json: 'CT2' }, body);
    }

    addReportFiling(document: DocumentType, filings: DocumentFilingType[]): void {
        let newFilings = cloneDeep(filings);

        newFilings.forEach((filing) => {
            filing.Edit_Status = 'A';
            filing.Book = { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID };
            filing.Book_Loc = { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID };

            if (!filing.File_Drawer) {
                filing.File_Drawer = '?';
            }

            if (!filing.File_Folder) {
                filing.File_Folder = '?';
            }

            if (!filing.Public_Document_Ind) {
                filing.Public_Document_Ind = 'N';
            }

            if (!filing.Common_Doc_Ind) {
                filing.Common_Doc_Ind = 'N';
            }

            if (!filing.Distribute) {
                filing.Distribute = { Method: 'F' };
            }

            if (filing.Distribute.Method == 'P') {
                filing.Distribute.Method = 'F';
            }

            if (filing.Distribute.Method == 'C') {
                if (filing.File_Only_Ind == 'Y') {
                    filing.Distribute.Method = 'F';
                } else {
                    filing.Distribute.Method = 'Q';
                }
            }
            if (filing.Contract?.Contract_ID < 1) {
                filing.Contract = undefined;
            }
        });

        this.reportProcessBody.ConceptOneRequest.ReportProcess.Document = {
            Doc_Class: document.Doc_Class,
            Filing: newFilings
        };

        if (this.reportSub) {
            this.reportSub.unsubscribe();
        }
        this.dsReportData.reset(); //so that current "READY" status won't fire for new subscription
        this.reportSub = this.dsReportData.status$
            .pipe(
                filter((status) => status === DataSourceStatus.Ready),
                map(() => this.reportDocumentUpdated())
            )
            .subscribe();
        this.dsReportData.process({ Object_Code: this.distributeService.callingObjectCode }, this.reportProcessBody);
    }

    documentUpdated() {
        this.taskOS.notifyDocumentSaved();
        if (this.callbackFunction) {
            this.callbackFunction();
            this.callbackFunction = null;
        }
        // if not already in a project then open the task header for the newly created task
        if (!this.taskOS.isProjectActive) {
            let taskID = this.dsDocument.tranNode.Task_ID;
            if (taskID) {
                this.taskOS.loadTask(taskID, false, this.taskLoaded.bind(this));
            }
        }
        this.taskOS.suppressTaskHeader(false);
    }

    reportDocumentUpdated() {
        this.taskOS.notifyDocumentSaved();
        if (this.callbackFunction) {
            this.callbackFunction();
            this.callbackFunction = null;
        }
        let newDoc = this.dsReportData.objectNode;

        let docDistStateEntities = this.store.selectSnapshot(DocumentDistributeObjectState.entities);

        for (var i in docDistStateEntities.document) {
            if (i != newDoc.Doc_ID) {
                this.documentDistributeOS.updateDocumentID(i, newDoc.Doc_ID);
            }
            break;
        }

        let taskID = this.dsReportData.tranNode.Task_ID;
        if (taskID) {
            this.reloadTaskID = taskID;
            this.taskOS.loadTask(taskID, false, this.taskLoaded.bind(this));
        }
        this.taskOS.suppressTaskHeader(false);
    }

    taskLoaded() {
        if (this.callPostDistribute) {
            this.callPostDistribute = false;

            let distMethod: string;
            let currDocument: any;
            let docDistStateEntities = this.store.selectSnapshot(DocumentDistributeObjectState.entities);
            docDistStateEntities = cloneDeep(docDistStateEntities);

            for (var i in docDistStateEntities.document) {
                currDocument = docDistStateEntities.document[i];
                distMethod = docDistStateEntities.document[i].Dist_Method;
                break; // only one document supported by this distribute function -- support multiple later?
            }
            this.distributeService.postDistribute(currDocument.Doc_ID, currDocument.Base_Doc_Type);

            //If not sending via quick correspond, reload task to navigate to next step or project tracker.
            if (this.reloadTaskID) {
                let taskID = this.reloadTaskID;
                this.reloadTaskID = null;
                if (distMethod != 'C') {
                    //Don't auto navigate to next task if document was distributed via Quick Correspond.
                    this.taskOS.loadTask(taskID, true);
                }
            }
        }
    }

    addNewDocumentWithFiling(Document: DocumentType, Filings: DocumentFilingType[]): void {
        let filingData = [];
        for (var i in Filings) {
            let Filing = Filings[i];

            let metaData = {
                Edit_Status: 'A',
                Book: { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID },
                Book_Loc: { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID }
            };
            Filing = { ...metaData, ...Filing };

            if (!Filing.File_Drawer) {
                Filing.File_Drawer = '?';
            }

            if (!Filing.File_Folder) {
                Filing.File_Folder = '?';
            }

            if (!Filing.Public_Document_Ind) {
                Filing.Public_Document_Ind = 'N';
            }

            if (!Filing.Common_Doc_Ind) {
                Filing.Common_Doc_Ind = 'N';
            }

            if (!Filing.Distribute) {
                Filing.Distribute = { Method: 'F' };
            }
            filingData.push(Filing);
        }

        // const documentProcess = {
        //   Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
        //   Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
        //   Event: parseInt(Document.Doc_ID) > 0 ? 'Update' : 'CREATE',
        //   ...(Document.Doc_Data['Doc_Format'].toLowerCase() === 'msg' && { Doc_Format: 'MIM' }),
        //   Document: {
        //     Doc_ID: Document.Doc_ID,
        //     Doc_Name: Document.Doc_Name,
        //     Doc_Desc: Document.Doc_Desc,
        //     Doc_Class: Document.Doc_Class,
        //     Doc_Data: Document.Doc_Data,
        //     Filing: {
        //       Edit_Status: 'A',
        //       Book: { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID },
        //       Book_Loc: { Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID },
        //       ...Filing
        //     }
        //   }
        // };
        let documentProcess;
        if (Document.Doc_Data) {
            documentProcess = {
                Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
                Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
                Event: parseInt(Document.Doc_ID) > 0 ? 'UPDATE' : 'CREATE',
                ...(Document.Doc_Data['Doc_Format'].toLowerCase() === 'msg' && { Doc_Format: 'MIM' }),
                Document: {
                    Doc_ID: Document.Doc_ID,
                    Doc_Name: Document.Doc_Name,
                    Doc_Desc: Document.Doc_Desc,
                    Doc_Class: Document.Doc_Class,
                    Doc_Data: Document.Doc_Data || null,
                    Filing: filingData
                }
            };
        } else {
            documentProcess = {
                Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
                Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
                Event: parseInt(Document.Doc_ID) > 0 ? 'UPDATE' : 'CREATE',
                Document: {
                    Doc_ID: Document.Doc_ID,
                    Doc_Name: Document.Doc_Name,
                    Doc_Desc: Document.Doc_Desc,
                    Doc_Class: Document.Doc_Class,
                    Filing: filingData
                }
            };
        }

        if (documentProcess.Document.Doc_Data && documentProcess.Document.Doc_Data == null) {
            delete documentProcess.Document.Doc_Data;
        }

        // Not passing a Task_ID will create a new task per Document
        const body = {
            '?xml': { '@version': '1.0' },
            ConceptOneRequest: {
                DocumentProcess: {
                    View: 'Full',
                    Keep_Project_Open: 'Y',
                    Session_ID: this.taskOS.currentProjectID,
                    ...documentProcess
                }
            }
        };

        if (this.documentSub) {
            this.documentSub.unsubscribe();
        }

        this.dsDocument.process({ json: 'CT2' }, body);
    }

    addNewDocumentWithoutFiling(Document: DocumentType): void {
        const documentProcess = {
            Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
            Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
            Event: 'Create',
            ...(Document.Doc_Data['Doc_Format'].toLowerCase() === 'msg' && { Doc_Format: 'MIM' }),
            Document: {
                Doc_ID: Document.Doc_ID,
                Doc_Name: Document.Doc_Name,
                Doc_Desc: Document.Doc_Desc,
                Doc_Class: Document.Doc_Class,
                Doc_Data: Document.Doc_Data
            }
        };

        const body = {
            '?xml': { '@version': '1.0' },
            ConceptOneRequest: {
                DocumentProcess: {
                    View: 'Full',
                    Session_ID: this.taskOS.currentProjectID,
                    Keep_Project_Open: 'Y',
                    ...documentProcess
                }
            }
        };

        if (this.documentSub) {
            this.documentSub.unsubscribe();
        }
        this.dsDocument.process({ json: 'CT2' }, body);
    }

    markDocumentViewed(docID: string, viewed: boolean = true): void {
        const documentProcess = {
            Book_Entity_ID: this.app.dsSystemInfo.objectNode.Context.Book.Entity_ID,
            Book_Loc_ID: this.app.dsSystemInfo.objectNode.Context.Book_Loc.Entity_ID,
            Event: 'Update',
            Document: {
                Doc_ID: docID,
                Viewed_Ind: viewed ? 'Y' : 'N'
            }
        };

        const body = {
            '?xml': { '@version': '1.0' },
            ConceptOneRequest: {
                DocumentProcess: {
                    View: 'Full',
                    Session_ID: this.taskOS.currentProjectID,
                    ...documentProcess
                }
            }
        };

        this.dsDocument.process({ json: 'CT2' }, body);
    }

    markDocumentUnViewed(docID: string): void {
        this.markDocumentViewed(docID, false);
    }
}
